import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { AuthProvider } from "react-oidc-context";

console.log('Application starting, window.APP_CONFIG:', window.APP_CONFIG);

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_uz9QrT6Qo",
  client_id: "14lmp7lfhglhmg6d84446r1gv5",
  //redirect_uri: process.env.COGNITO__REDIRECT_URI,
  redirect_uri: "https://lingoppia.com",
  //commented this (aboive) out on 11/14/2025 - trying to get the test environment to flip back to the local host. Uncomment the above and kill the process.env.COGNITO__REDIRECT_URI
  //to get this to work. note that one was updated too. Flip them back to the lingoppia things, not the localhost stuff. and then comment the redirect_uri: "http://localhost:3000"
  //reverse this to use as test environment
  //redirect_uri: "http://localhost:3000",
  response_type: "code",
  scope: "phone openid email",
  };

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
    <App />
    </AuthProvider>
  </React.StrictMode>
);

